import {createFileRoute} from '@tanstack/react-router';

import Psoriasis from '@/patient/views/PathologiesInfo/Psoriasis';

export const Route = createFileRoute('/(patient)/patient/psoriasis-info')({
  component: Psoriasis
});
